// extracted by mini-css-extract-plugin
export default {"modalWrap":"ModalModify_modalWrap__QhESG","modalInner":"ModalModify_modalInner__CELnM","btnBox":"ModalModify_btnBox__WlsRY"};